<div class="comparison-container">
  <!-- Header -->
  <div class="comparison-header-bar">
    <h3>Realizat vs Buget: {{ budgetGroup.name }}</h3>
  </div>

  <!-- Simple month+year selector -->
  <div class="simple-selector">
    <h4>Selecteaza luna si anul pentru comparatie:</h4>
    <div class="selector-row">
      <nz-select [(ngModel)]="selectedMonth" style="width: 150px;" nzSize="default">
        <nz-option *ngFor="let m of months" [nzValue]="m.value" [nzLabel]="m.label"></nz-option>
      </nz-select>
      <nz-select [(ngModel)]="selectedYear" style="width: 100px; margin-left: 8px;" nzSize="default">
        <nz-option *ngFor="let y of availableYears" [nzValue]="y" [nzLabel]="y.toString()"></nz-option>
      </nz-select>
      <button nz-button nzType="primary" (click)="checkAutoMatch()" [nzLoading]="checkingMatch" style="margin-left: 12px;">
        Verifica daca ai informatii pentru buget si realizat
      </button>
    </div>

    <!-- Only show warnings for NOT FOUND -- NO message when found -->
    <div *ngIf="autoMatchResult" style="margin-top: 12px;">
      <nz-alert *ngIf="autoMatchResult.missingBudget"
        nzType="warning"
        nzMessage="Nu a fost gasit un buget care acopera aceasta perioada."
        nzShowIcon>
      </nz-alert>
      <nz-alert *ngIf="autoMatchResult.missingRealized"
        nzType="warning"
        nzMessage="Nu a fost gasit un raport realizat pentru aceasta luna."
        nzShowIcon>
      </nz-alert>
      <button *ngIf="!autoMatchResult.missingBudget && !autoMatchResult.missingRealized"
        nz-button nzType="primary" (click)="addToComparison()" style="margin-top: 8px;">
        + Adauga la comparatie
      </button>
    </div>
  </div>

  <!-- Added months chips -->
  <div *ngIf="comparisonMonths.length > 0" class="added-months" style="margin-top: 16px; margin-bottom: 16px;">
    <nz-tag *ngFor="let cm of comparisonMonths; let i = index" nzMode="closeable" (nzOnClose)="removeComparisonMonth(i)" [nzColor]="'blue'"
      style="font-size: 16px; padding: 6px 14px; line-height: 1.6;">
      {{ cm.label }}
    </nz-tag>
  </div>

  <div class="comparison-actions">
    <button nz-button (click)="exportComparisonExcel()" [disabled]="!comparisonData" style="margin-right: 8px;">
      Export Excel
    </button>
    <button nz-button (click)="exportComparisonPdf()" [disabled]="!comparisonData" style="margin-right: 8px;">
      Export PDF
    </button>
    <button nz-button (click)="openComparisonEmailModal()" [disabled]="!comparisonData" style="margin-right: 8px;">
      Trimite pe email
    </button>
    <button nz-button nzType="primary" (click)="loadComparison()" [nzLoading]="loadingComparison" [disabled]="comparisonMonths.length === 0">
      Genereaza comparatie
    </button>
  </div>

  <!-- Comparison table -->
  <div *ngIf="comparisonData" class="comparison-table-wrapper">
    <nz-table
      #compTable
      [nzData]="getComparisonRows()"
      nzSize="small"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
      [nzScroll]="{ x: getTableScrollX() }"
    >
      <thead>
        <!-- Multi-year header: Row 1 = years, Row 2 = months, Row 3 = sub-headers -->
        <ng-container *ngIf="hasMultipleComparisonYears">
          <tr>
            <th nzLeft nzWidth="260px" [attr.rowspan]="3" class="description-header">Descriere</th>
            <ng-container *ngFor="let yg of comparisonYearGroups">
              <th [attr.colspan]="getComparisonYearColspan(yg.year)"
                  class="year-group-header text-center"
                  (click)="toggleComparisonYear(yg.year)"
                  style="cursor: pointer;">
                {{ expandedYears.has(yg.year) ? '▼' : '▶' }} {{ yg.year }}
              </th>
            </ng-container>
          </tr>
          <tr>
            <ng-container *ngFor="let mp of visibleAssignedMonths">
              <th [attr.colspan]="colsPerMonth"
                  class="month-group-header text-center">
                {{ mp.isYearTotal ? 'Total' : mp.label }}
              </th>
            </ng-container>
          </tr>
          <tr>
            <ng-container *ngFor="let mp of visibleAssignedMonths">
              <th nzWidth="120px" class="sub-header text-right">Realizat YTD</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_realistic">Buget Realist YTD</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_pessimistic">Buget Pesimist YTD</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_realistic">Variație Realist</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_pessimistic">Variație Pesimist</th>
            </ng-container>
          </tr>
        </ng-container>
        <!-- Single-year header: Row 1 = months, Row 2 = sub-headers -->
        <ng-container *ngIf="!hasMultipleComparisonYears">
          <tr>
            <th nzLeft nzWidth="260px" rowspan="2" class="description-header">Descriere</th>
            <ng-container *ngFor="let mp of assignedMonths">
              <th [attr.colspan]="colsPerMonth"
                  class="month-group-header text-center">
                {{ mp.label }}
              </th>
            </ng-container>
          </tr>
          <tr>
            <ng-container *ngFor="let mp of assignedMonths">
              <th nzWidth="120px" class="sub-header text-right">Realizat YTD</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_realistic">Buget Realist YTD</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_pessimistic">Buget Pesimist YTD</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_realistic">Variație Realist</th>
              <th nzWidth="120px" class="sub-header text-right" *ngIf="comparisonData.has_pessimistic">Variație Pesimist</th>
            </ng-container>
          </tr>
        </ng-container>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of compTable.data">
          <!-- Main row -->
          <tr [class.computed-row]="row.is_computed">
            <td nzLeft *ngIf="!row.is_computed && hasAnyAccounts(row.sort_order)">
              <button (click)="onExpandChange(row.sort_order, !expandSet.has(row.sort_order))"
                      class="expand-toggle">
                {{ expandSet.has(row.sort_order) ? '−' : '+' }}
              </button>
              {{ row.description }}
            </td>
            <td nzLeft *ngIf="row.is_computed || !hasAnyAccounts(row.sort_order)">
              <strong *ngIf="row.is_computed">{{ row.description }}</strong>
              <span *ngIf="!row.is_computed">{{ row.description }}</span>
            </td>
            <ng-container *ngFor="let mp of visibleAssignedMonths">
              <!-- Individual month cells (all YTD) -->
              <ng-container *ngIf="!mp.isYearTotal">
                <!-- Realizat YTD -->
                <td class="text-right"
                    [class.negative-value]="getYtdField(row.sort_order, mp.month, mp.year, 'realized') < 0">
                  <ng-container *ngIf="getYtdField(row.sort_order, mp.month, mp.year, 'realized') !== null">
                    <ng-container *ngIf="row.description.startsWith('%')">{{ getYtdField(row.sort_order, mp.month, mp.year, 'realized') | number:'1.1-1':'ro' }} %</ng-container>
                    <ng-container *ngIf="!row.description.startsWith('%')">{{ getYtdField(row.sort_order, mp.month, mp.year, 'realized') | number:'1.0-0':'ro' }}</ng-container>
                  </ng-container>
                  <span *ngIf="getYtdField(row.sort_order, mp.month, mp.year, 'realized') === null" class="no-data">—</span>
                </td>
                <!-- Buget Realist YTD -->
                <td class="text-right" *ngIf="comparisonData.has_realistic">
                  <ng-container *ngIf="getYtdField(row.sort_order, mp.month, mp.year, 'realistic_budget') !== null">
                    <ng-container *ngIf="row.description.startsWith('%')">{{ getYtdField(row.sort_order, mp.month, mp.year, 'realistic_budget') | number:'1.1-1':'ro' }} %</ng-container>
                    <ng-container *ngIf="!row.description.startsWith('%')">{{ getYtdField(row.sort_order, mp.month, mp.year, 'realistic_budget') | number:'1.0-0':'ro' }}</ng-container>
                  </ng-container>
                  <span *ngIf="getYtdField(row.sort_order, mp.month, mp.year, 'realistic_budget') === null" class="no-data">—</span>
                </td>
                <!-- Buget Pesimist YTD -->
                <td class="text-right" *ngIf="comparisonData.has_pessimistic">
                  <ng-container *ngIf="getYtdField(row.sort_order, mp.month, mp.year, 'pessimistic_budget') !== null">
                    <ng-container *ngIf="row.description.startsWith('%')">{{ getYtdField(row.sort_order, mp.month, mp.year, 'pessimistic_budget') | number:'1.1-1':'ro' }} %</ng-container>
                    <ng-container *ngIf="!row.description.startsWith('%')">{{ getYtdField(row.sort_order, mp.month, mp.year, 'pessimistic_budget') | number:'1.0-0':'ro' }}</ng-container>
                  </ng-container>
                  <span *ngIf="getYtdField(row.sort_order, mp.month, mp.year, 'pessimistic_budget') === null" class="no-data">—</span>
                </td>
                <!-- Variație Realist (YTD realized - YTD budget) -->
                <td class="text-right" *ngIf="comparisonData.has_realistic"
                    [class.positive-variation]="getYtdVariation(row.sort_order, mp.month, mp.year, 'realistic_budget') > 0"
                    [class.negative-variation]="getYtdVariation(row.sort_order, mp.month, mp.year, 'realistic_budget') < 0">
                  <ng-container *ngIf="getYtdVariation(row.sort_order, mp.month, mp.year, 'realistic_budget') !== null">
                    <ng-container *ngIf="row.description.startsWith('%')">{{ getYtdVariation(row.sort_order, mp.month, mp.year, 'realistic_budget') | number:'1.1-1':'ro' }} %</ng-container>
                    <ng-container *ngIf="!row.description.startsWith('%')">{{ getYtdVariation(row.sort_order, mp.month, mp.year, 'realistic_budget') | number:'1.0-0':'ro' }}</ng-container>
                  </ng-container>
                  <span *ngIf="getYtdVariation(row.sort_order, mp.month, mp.year, 'realistic_budget') === null" class="no-data">—</span>
                </td>
                <!-- Variație Pesimist (YTD realized - YTD budget) -->
                <td class="text-right" *ngIf="comparisonData.has_pessimistic"
                    [class.positive-variation]="getYtdVariation(row.sort_order, mp.month, mp.year, 'pessimistic_budget') > 0"
                    [class.negative-variation]="getYtdVariation(row.sort_order, mp.month, mp.year, 'pessimistic_budget') < 0">
                  <ng-container *ngIf="getYtdVariation(row.sort_order, mp.month, mp.year, 'pessimistic_budget') !== null">
                    <ng-container *ngIf="row.description.startsWith('%')">{{ getYtdVariation(row.sort_order, mp.month, mp.year, 'pessimistic_budget') | number:'1.1-1':'ro' }} %</ng-container>
                    <ng-container *ngIf="!row.description.startsWith('%')">{{ getYtdVariation(row.sort_order, mp.month, mp.year, 'pessimistic_budget') | number:'1.0-0':'ro' }}</ng-container>
                  </ng-container>
                  <span *ngIf="getYtdVariation(row.sort_order, mp.month, mp.year, 'pessimistic_budget') === null" class="no-data">—</span>
                </td>
              </ng-container>
              <!-- Year total cells (collapsed year) -->
              <ng-container *ngIf="mp.isYearTotal">
                <td class="text-right" [class.negative-value]="getYearRowValue(row.sort_order, mp.year, 'realized') < 0">
                  <strong *ngIf="row.description.startsWith('%')">{{ getYearRowValue(row.sort_order, mp.year, 'realized') | number:'1.1-1':'ro' }} %</strong>
                  <strong *ngIf="!row.description.startsWith('%')">{{ getYearRowValue(row.sort_order, mp.year, 'realized') | number:'1.0-0':'ro' }}</strong>
                </td>
                <td class="text-right" *ngIf="comparisonData.has_realistic">
                  <strong *ngIf="row.description.startsWith('%')">{{ getYearRowValue(row.sort_order, mp.year, 'realistic_budget') | number:'1.1-1':'ro' }} %</strong>
                  <strong *ngIf="!row.description.startsWith('%')">{{ getYearRowValue(row.sort_order, mp.year, 'realistic_budget') | number:'1.0-0':'ro' }}</strong>
                </td>
                <td class="text-right" *ngIf="comparisonData.has_pessimistic">
                  <strong *ngIf="row.description.startsWith('%')">{{ getYearRowValue(row.sort_order, mp.year, 'pessimistic_budget') | number:'1.1-1':'ro' }} %</strong>
                  <strong *ngIf="!row.description.startsWith('%')">{{ getYearRowValue(row.sort_order, mp.year, 'pessimistic_budget') | number:'1.0-0':'ro' }}</strong>
                </td>
                <td class="text-right" *ngIf="comparisonData.has_realistic"
                    [class.positive-variation]="getYearVariation(row.sort_order, mp.year, 'realistic_budget') > 0"
                    [class.negative-variation]="getYearVariation(row.sort_order, mp.year, 'realistic_budget') < 0">
                  <strong *ngIf="row.description.startsWith('%')">{{ getYearVariation(row.sort_order, mp.year, 'realistic_budget') | number:'1.1-1':'ro' }} %</strong>
                  <strong *ngIf="!row.description.startsWith('%')">{{ getYearVariation(row.sort_order, mp.year, 'realistic_budget') | number:'1.0-0':'ro' }}</strong>
                </td>
                <td class="text-right" *ngIf="comparisonData.has_pessimistic"
                    [class.positive-variation]="getYearVariation(row.sort_order, mp.year, 'pessimistic_budget') > 0"
                    [class.negative-variation]="getYearVariation(row.sort_order, mp.year, 'pessimistic_budget') < 0">
                  <strong *ngIf="row.description.startsWith('%')">{{ getYearVariation(row.sort_order, mp.year, 'pessimistic_budget') | number:'1.1-1':'ro' }} %</strong>
                  <strong *ngIf="!row.description.startsWith('%')">{{ getYearVariation(row.sort_order, mp.year, 'pessimistic_budget') | number:'1.0-0':'ro' }}</strong>
                </td>
              </ng-container>
            </ng-container>
          </tr>
          <!-- Account detail rows (inline in parent table, sharing columns & scroll) -->
          <ng-container *ngIf="expandSet.has(row.sort_order) && hasAnyAccounts(row.sort_order)">
            <tr *ngFor="let acct of getUniqueAccounts(row.sort_order)" class="account-detail-row">
              <td nzLeft style="padding-left: 40px;">
                <span class="detail-account-code">{{ acct.accountCode }}</span>
                <span class="detail-account-desc">{{ acct.accountDescription }}</span>
              </td>
              <ng-container *ngFor="let mp of visibleAssignedMonths">
                <ng-container *ngIf="!mp.isYearTotal">
                  <!-- Realizat YTD -->
                  <td class="text-right">
                    <ng-container *ngIf="getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year) !== null">
                      {{ getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year) | number:'1.0-0':'ro' }}
                    </ng-container>
                    <span *ngIf="getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year) === null" class="no-data">—</span>
                  </td>
                  <!-- Buget Realist YTD -->
                  <td *ngIf="comparisonData.has_realistic" class="text-right">
                    <ng-container *ngIf="getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetRealistic') !== null">
                      {{ getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetRealistic') | number:'1.0-0':'ro' }}
                    </ng-container>
                  </td>
                  <!-- Buget Pesimist YTD -->
                  <td *ngIf="comparisonData.has_pessimistic" class="text-right">
                    <ng-container *ngIf="getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetPessimistic') !== null">
                      {{ getYtdAccountField(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetPessimistic') | number:'1.0-0':'ro' }}
                    </ng-container>
                  </td>
                  <!-- Variație Realist YTD -->
                  <td *ngIf="comparisonData.has_realistic" class="text-right"
                      [class.positive-variation]="getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetRealistic') > 0"
                      [class.negative-variation]="getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetRealistic') < 0">
                    <ng-container *ngIf="getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetRealistic') !== null">
                      {{ getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetRealistic') | number:'1.0-0':'ro' }}
                    </ng-container>
                  </td>
                  <!-- Variație Pesimist YTD -->
                  <td *ngIf="comparisonData.has_pessimistic" class="text-right"
                      [class.positive-variation]="getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetPessimistic') > 0"
                      [class.negative-variation]="getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetPessimistic') < 0">
                    <ng-container *ngIf="getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetPessimistic') !== null">
                      {{ getYtdAccountVariation(row.sort_order, acct.accountCode, mp.month, mp.year, 'budgetPessimistic') | number:'1.0-0':'ro' }}
                    </ng-container>
                  </td>
                </ng-container>
                <ng-container *ngIf="mp.isYearTotal">
                  <td class="text-right">
                    <strong>{{ getYearAccountField(row.sort_order, acct.accountCode, mp.year, 'value') | number:'1.0-0':'ro' }}</strong>
                  </td>
                  <td *ngIf="comparisonData.has_realistic" class="text-right">
                    <strong>{{ getYearAccountField(row.sort_order, acct.accountCode, mp.year, 'budgetRealistic') | number:'1.0-0':'ro' }}</strong>
                  </td>
                  <td *ngIf="comparisonData.has_pessimistic" class="text-right">
                    <strong>{{ getYearAccountField(row.sort_order, acct.accountCode, mp.year, 'budgetPessimistic') | number:'1.0-0':'ro' }}</strong>
                  </td>
                  <td *ngIf="comparisonData.has_realistic" class="text-right">
                    <strong>{{ getYearAccountVariation(row.sort_order, acct.accountCode, mp.year, 'budgetRealistic') | number:'1.0-0':'ro' }}</strong>
                  </td>
                  <td *ngIf="comparisonData.has_pessimistic" class="text-right">
                    <strong>{{ getYearAccountVariation(row.sort_order, acct.accountCode, mp.year, 'budgetPessimistic') | number:'1.0-0':'ro' }}</strong>
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </nz-table>
  </div>

  <!-- Chart section -->
  <div *ngIf="comparisonData && chartChapters.length > 0" class="chart-section">
    <div class="chart-header">
      <strong>Grafic evoluție</strong>
      <nz-select
        [(ngModel)]="selectedChartSort"
        (ngModelChange)="onChartChapterChange()"
        style="width: 320px; margin-left: 12px;"
        nzSize="default"
        class="chart-chapter-select"
      >
        <nz-option
          *ngFor="let ch of chartChapters"
          [nzValue]="ch.sort_order"
          [nzLabel]="ch.description"
        ></nz-option>
      </nz-select>
    </div>
    <div *ngIf="barChartDatasets.length > 0" class="chart-body" style="height: 360px;">
      <canvas baseChart
        [datasets]="barChartDatasets"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="true"
        chartType="bar">
      </canvas>
    </div>
  </div>

  <!-- Budget guidance info card -->
  <div *ngIf="budgetGuidanceContent" class="guidance-card" style="margin-top: 24px;">
    <nz-collapse>
      <nz-collapse-panel
        nzHeader="Informații suplimentare pentru întocmirea bugetului"
        [nzActive]="false">
        <div [innerHTML]="budgetGuidanceContent"></div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>

  <!-- Send by Email Modal -->
  <nz-modal
    [(nzVisible)]="showEmailModal"
    nzTitle="Trimite comparația pe email"
    (nzOnCancel)="showEmailModal = false"
    (nzOnOk)="sendComparisonByEmail()"
    nzOkText="Trimite"
    [nzOkLoading]="sendingEmail"
    [nzWidth]="450"
  >
    <ng-container *nzModalContent>
      <nz-form-item>
        <nz-form-label>Adresa de email</nz-form-label>
        <nz-form-control>
          <input nz-input [(ngModel)]="emailAddress" placeholder="email@exemplu.ro" type="email" />
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  </nz-modal>
</div>
